import { action, thunk } from 'easy-peasy';

const global = {
  activity: false,
  setActivity: action((state, payload) => {
    state.activity = payload;
  }),

  selectDriver: '',
  setSelectDriver: action((state, payload) => {
    state.selectDriver = payload;
    state.selectMarchandise = '';
  }),

  selectMarchandise: '',
  setSelectMarchandise: action((state, payload) => {
    state.selectMarchandise = payload;
    state.selectDriver = '';
  }),

  warnningConstructionSite: false,
  setWarnningConstructionSite: action((state, payload) => {
    state.warnningConstructionSite = payload;
  }),

  warnningNewClient: false,
  setWarnningNewClient: action((state, payload) => {
    state.warnningNewClient = payload;
  }),

  authorizationConsents: [],
  setAuthorizationConsents: action((state, payload) => {
    state.authorizationConsents = payload || [];
  }),

  collaborators : [],
  setCollaborators : action((state, payload) => {
    state.collaborators = payload || [];
  }),
};

export default global;
